import React from 'react';

/**
 * BLOCK PART: section heading
 * ACF: reused as a field group (`section_heading`) inside most block layouts.
 *
 * Fields:
 *  - eyebrow   (text, optional)
 *  - heading   (text)
 *  - intro     (textarea, optional)
 *  - align     (select: left | center)
 *  - tone      (select: light | dark — dark = for use on dark backgrounds)
 *  - level     (select: h2 | h3)
 *
 * This is a composition helper rather than a standalone block; it removes the
 * eyebrow/heading/intro triplet that was duplicated across ~30 sections.
 */

interface SectionHeadingProps {
  eyebrow?: string;
  heading: React.ReactNode;
  intro?: React.ReactNode;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  accent?: 'sage' | 'rose';
  level?: 'h2' | 'h3';
  id?: string;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  heading,
  intro,
  align = 'left',
  tone = 'light',
  accent = 'sage',
  level = 'h2',
  id,
  className = ''
}: SectionHeadingProps) {
  const Heading = level;
  const isDark = tone === 'dark';
  const eyebrowColor = isDark ? accent === 'rose' ? 'text-rose' : 'text-sage-100' : accent === 'rose' ? 'text-rose-700' : 'text-sage-700';
  return <div className={`${align === 'center' ? 'text-center' : ''} ${className}`} data-id="element-176" data-mp="m46gbt6gzowh">
      {eyebrow && <p className={`text-xs font-medium tracking-[0.26em] uppercase ${eyebrowColor}`} data-id="element-177" data-mp="r3j02521ofuu">
          {eyebrow}
        </p>}
      <Heading id={id} className={`font-serif text-4xl leading-tight sm:text-5xl ${eyebrow ? 'mt-4' : ''} ${isDark ? 'text-cream' : 'text-charcoal'}`} data-id="element-178" data-mp="1euer2zyof711">
        {heading}
      </Heading>
      {intro && <div className={`mt-5 space-y-4 text-base font-light leading-relaxed ${isDark ? 'text-cream-100/80' : 'text-charcoal-50'} ${align === 'center' ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`} data-id="element-179" data-mp="1a0aiyddocsyd">
          {typeof intro === 'string' ? <p data-id="element-180" data-mp="2cdd9c2eryyxr">{intro}</p> : intro}
        </div>}
    </div>;
}